import clsx from "clsx"
import { FC } from "react"
import {
  StoneFlexModalBottomLeftImg,
  StoneFlexModalBottomRightImg,
  StoneFlexModalBreakpointBottomImg,
  StoneFlexModalBreakpointTopImg,
  StoneFlexModalStonesLeftImg,
  StoneFlexModalStonesRightImg,
  StoneFlexModalStonesTopImg,
  StoneFlexModalTopLeftImg,
  StoneFlexModalTopRightImg
} from "@/assets"
import styles from "./ModalStoneFrame.module.scss"

export const ModalStoneFrame: FC = () => {
  return (
    <div className={clsx(styles.ModalStoneFrame)}>
      <div className={clsx(styles.ModalStoneFrame_angle, styles.tl)}>
        <img src={StoneFlexModalTopLeftImg} alt="stone-angle" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_angle, styles.tr)}>
        <img src={StoneFlexModalTopRightImg} alt="stone-angle" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_angle, styles.bl)}>
        <img src={StoneFlexModalBottomLeftImg} alt="stone-angle" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_angle, styles.br)}>
        <img src={StoneFlexModalBottomRightImg} alt="stone-angle" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_breakpoint, styles.tl)}>
        <img src={StoneFlexModalBreakpointTopImg} alt="stone-breakpoint" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_breakpoint, styles.tr)}>
        <img src={StoneFlexModalBreakpointTopImg} alt="stone-breakpoint" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_breakpoint, styles.bl)}>
        <img src={StoneFlexModalBreakpointBottomImg} alt="stone-breakpoint" />
      </div>
      <div className={clsx(styles.ModalStoneFrame_breakpoint, styles.br)}>
        <img src={StoneFlexModalBreakpointBottomImg} alt="stone-breakpoint" />
      </div>
      <div
        className={clsx(styles.ModalStoneFrame_stones, styles.left)}
        style={{
          backgroundImage: `url(${StoneFlexModalStonesLeftImg})`
        }}
      />
      <div
        className={clsx(styles.ModalStoneFrame_stones, styles.right)}
        style={{
          backgroundImage: `url(${StoneFlexModalStonesRightImg})`
        }}
      />
      <div
        className={clsx(styles.ModalStoneFrame_stones, styles.top)}
        style={{
          backgroundImage: `url(${StoneFlexModalStonesTopImg})`
        }}
      />
    </div>
  )
}
